import { Empty, Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { spacing } from '../../theming';
import { documentLinks } from '../../utils/vinExtraction';
import CarDocumentLink from './CarDocumentLink';

const CarDocumentList = ({ items }) => {
    const { t } = useTranslation('vinExtraction');

    if (!items.length) return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('drawer.documents.empty')} />;

    return (
        <Flex vertical gap={spacing[0.5]} component="ul" style={{ listStyle: 'none', margin: 0, padding: 0 }}>
            {documentLinks(items).map(link => (
                <CarDocumentLink key={link.key} link={link} />
            ))}
        </Flex>
    );
};

export default CarDocumentList;
